// extracted by mini-css-extract-plugin
export default {"flexRow":"styles_flexRow__N20CR","currencyWrapper":"styles_currencyWrapper__6yAQG","checkbox":"styles_checkbox__CYNwt","accents":"styles_accents__R8QKR"};